<template>
  <section>
    <h2> 互除法の実行 </h2>
    <div>
      <div class="math"> a <span class="equal"> =  </span> <Showint :x="a" :color="1"/> </div>
      <div class="math"> b <span class="equal"> =  </span> <Showint :x="b" :color="2"/> </div>
    </div>
    <hr />
    <div v-for="(entry,i) in partialHistory" class="math" :key="'euc' + i" ref="eqn">
      <Showint :x="entry.p1" :color="i%5+1" /> <span class="equal"> =  </span>
      <Showint :x="entry.p2" :brace="true" :color="(i+1)%5+1"/>
      <span class="equal"> × </span>
      <span v-if="question && i == partialHistory.length -1" class="question"> ? </span>
      <Showint v-else :x="entry.q" :brace="true" />
      <span class="equal"> + </span>
      <span v-if="question && i == partialHistory.length -1" class="question"> ? </span>
      <Showint v-else :x="entry.r" :brace="true" :color="(i+2)%5+1"/>
    </div>
    <div v-if="! showResult" class="math">
      <button v-if="question" @click="next"> 計算を実行 </button>
      <button v-else @click="next"> 次の割り算 </button>
    </div>
    <template v-if="showResult">
      aとbの最大公約数は
      <div class="math">
	<Showint :x="gcd" :color="history.length%5+1" />
      </div>
      <hr />
      <div class="math">
	<Showint :x="gcd" :color="history.length%5+1" />
      </div>
      <template v-for="(entry,i) in reverse" class="math">
	<div v-if="! entry.end" class="math" :key="'rev' + i">
	  <span class="equal"> = </span>
	  <Showint :x="entry.p2" :color="(entry.color +1)% 5 + 1" :brace="true"/>
	  <span class="equal"> × </span>
	  <Showint :x="entry.z3" :brace="true"/>
	  <span class="equal"> + </span>
	  <span class="brace1"> { </span>
	  <span class="equal">
	    <Showint :x="entry.p1" :color="(entry.color) % 5 +1" :brace="true"/>
	    <span class="equal"> - </span>
	    <Showint :x="entry.p2" :color="(entry.color +1) % 5 +1" :brace="true"/>
	    <span class="equal"> × </span>
	    <Showint :x="entry.q" :brace="true"/>
	  </span>
	  <span class="brace1"> } </span>
	  <span class="equal"> × </span>
	  <Showint :x="entry.z1" :brace="true"/>		
	</div>
	<div class="math" :key="'revv' + i">
	  <span class="equal"> = </span>
	  <template v-if="entry.p1 != 0">
	    <Showint :x="entry.p1" :color="entry.color % 5 +1" :brace="true"/>
	    <span class="equal"> × </span>
	    <Showint :x="entry.z1" :brace="true"/>
	    <span class="equal"> + </span>
	  </template>
	  <Showint :x="entry.p2" :color="(entry.color +1) % 5 +1" :brace="true"/>
	  <span class="equal"> × </span>
	  <Showint :x="entry.z2" :brace="true"/>	
	</div>
      </template>
    </template>
  </section>
</template>

<script>
import Showint from '@/components/Showint'

export default {
  name: 'EuclidInt',
  components: {
    Showint
  },
  props: {
    a: Number,
    b: Number
  },
  data: function(){
    return {
      history: [],
      gcd: 1,
      reverse: [],
      counter: 0,
      question: false,
      showResult: false,
    }
  },
  computed: {
    partialHistory(){
      return this.history.slice(0,this.counter);
    }
  },
  created: function(){
    let p1 = this.a;
    let p2 = this.b;
    while(p2 != 0){
      const r = ((p1 % p2) + Math.abs(p2)) % p2;
      const q = (p1-r)/p2;
      this.history.push({p1:p1, p2:p2, q:q, r:r});
      p1 = p2;
      p2 = r;
    }
    this.gcd = this.history[this.history.length-1].p2;
    if(this.history.length == 1){
      this.reverse.push({
	end: true,
	color: 0,
	p1: this.history[0].p1,
	z1: 0,
	p2: this.history[0].p2,
	z2: 1
      });
    }else{
      let z1 = 1;
      let z2 = -this.history[this.history.length-2].q;
      let z3 = 0;
      this.reverse.push({
	end: true,
	color: this.history.length-2,
	p1: this.history[this.history.length-2].p1,
	z1: z1,
	p2: this.history[this.history.length-2].p2,
	z2: z2
      });
      for(let n = this.history.length-3; n>=0;n--){
	z3 = z1;
	z1 = z2;
	z2 = z3 - this.history[n].q * z1;
	this.reverse.push({
	  end: false,
	  color: n,
	  p1: this.history[n].p1,
	  p2: this.history[n].p2,
	  q: this.history[n].q,
	  z1: z1,
	  z2: z2,
	  z3: z3,
	});	
      }
    }
  },
  methods: {
    next(){
      if(this.question){
	this.question = false;
	if(this.counter == this.history.length){
	  this.showResult = true;
	}
      }else{
	this.counter += 1;
	this.question = true;
	this.$nextTick( () => {
	  if(this.$refs.eqn && this.$refs.eqn.length > 0){
	    this.$refs.eqn[this.$refs.eqn.length -1].scrollIntoView()
	  }
	});
      }
    }
  }
}
</script>

<style scoped>
</style>
